/*
  Vista rápida AoA (Bryan, 2026-10-05) · complementos de la galería del cajón #Product-Drawer.
  - Filtro por color: al cambiar de variante (evento product:variant-change de assets/product.js) solo quedan
    las fotos cuyo data-color-group coincide con el color elegido; si ese color no tiene fotos, se ven todas.
    Mismo criterio que la ficha (assets/pdp-hero.js). Después avisa al riel (<aoa-rail>.update) y vuelve al inicio.
  - Escritorio: la columna de fotos se arrastra con el mouse de arriba abajo (pointer events, solo mouse;
    en táctil ya se desliza con el dedo). Un arrastre corto cuenta como clic.
  Todo con delegación en document: el contenido del cajón se inyecta y se reemplaza en cada apertura.
*/
(function () {
  'use strict';

  function galeria() {
    return document.querySelector('#Product-Drawer .qv-gallery');
  }

  /* ---------- filtro por color ---------- */
  function filtrarPorColor(rail, variant) {
    if (!rail || !variant) return;
    var iColor = Number(rail.getAttribute('data-color-index'));
    if (!(iColor >= 0)) return;
    var opciones = variant.options || [];
    var color = String(opciones[iColor] || '').toLowerCase().trim();
    if (!color) return;
    var slides = Array.prototype.slice.call(rail.querySelectorAll('.product-quick-images__slide'));
    var hay = slides.some(function (s) { return (s.getAttribute('data-color-group') || '').toLowerCase() === color; });
    slides.forEach(function (s) {
      var fuera = hay && (s.getAttribute('data-color-group') || '').toLowerCase() !== color;
      s.classList.toggle('is-color-hidden', fuera);
    });
    rail.setAttribute('data-color-filter', hay ? 'on' : 'off');
    var track = rail.querySelector('.product-quick-images');
    if (track) {
      track.scrollTo({ left: 0, top: 0, behavior: 'auto' });
    }
    if (typeof rail.update === 'function') {
      requestAnimationFrame(function () { rail.update(); });
    }
  }

  document.addEventListener('product:variant-change', function (e) {
    var rail = galeria();
    if (!rail) return;
    var datos = (e && e.detail) || {};
    // Solo la vista rápida: el evento de la ficha trae otro sectionId
    var seccion = rail.closest('.thb-product-detail');
    if (seccion && datos.sectionId) {
      var selects = seccion.querySelector('variant-selects');
      if (selects && selects.dataset.section && selects.dataset.section !== datos.sectionId) return;
    }
    filtrarPorColor(rail, datos.variant);
  });

  /* ---------- arrastre vertical con el mouse (escritorio) ---------- */
  var gesto = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('#Product-Drawer .qv-gallery .product-quick-images');
    if (!track) return;
    if (track.scrollHeight <= track.clientHeight + 1) return; // nada que desplazar
    gesto = { track: track, y: e.clientY, top: track.scrollTop, movido: false, id: e.pointerId };
    track.setPointerCapture && track.setPointerCapture(e.pointerId);
  });

  document.addEventListener('pointermove', function (e) {
    if (!gesto || e.pointerId !== gesto.id) return;
    var dy = e.clientY - gesto.y;
    if (!gesto.movido && Math.abs(dy) < 4) return;
    gesto.movido = true;
    gesto.track.classList.add('is-dragging');
    gesto.track.scrollTop = gesto.top - dy;
    e.preventDefault();
  });

  function soltar(e) {
    if (!gesto || (e && e.pointerId !== gesto.id)) return;
    var t = gesto.track, movido = gesto.movido;
    t.classList.remove('is-dragging');
    t.releasePointerCapture && e && t.releasePointerCapture(e.pointerId);
    gesto = null;
    if (movido) {
      // El clic que cierra el arrastre no debe contar como clic en la foto
      var tapar = function (ev) { ev.stopPropagation(); ev.preventDefault(); t.removeEventListener('click', tapar, true); };
      t.addEventListener('click', tapar, true);
      setTimeout(function () { t.removeEventListener('click', tapar, true); }, 0);
    }
  }

  /* ---------- talla agotada: el botón lleva a la ficha con la variante elegida (ahí se deja el correo) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#Product-Drawer [data-qv-notify]');
    if (!a) return;
    var campo = document.querySelector('#Product-Drawer form[action*="/cart/add"] [name="id"]');
    if (!campo || !campo.value) return;
    e.preventDefault();
    window.location.href = a.getAttribute('href').split('?')[0] + '?variant=' + encodeURIComponent(campo.value);
  });

  document.addEventListener('pointerup', soltar);
  document.addEventListener('pointercancel', soltar);
})();
